import axios from "../../axios";

const api = {
  getBusinessTravelItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/business-travel/items`,
      config).then(({ data }) => data);
  },

  addBusinessTravelItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/business-travel/items`, data, headers)
      .then(({ data }) => data);
  },

  updateBusinessTravelItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/business-travel/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteBusinessTravelItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/business-travel/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importBusinessTravelItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/business-travel/items/import`, data, headers).then(({ data }) => data);
  },

  downloadBusinessTravelTemplate(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/business-travel/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "Scope3_Category6_template";
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;